import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Parse from '../../Parse';

import './UserProfileHeader.css';
import UserLogo from '../../assets/user.jpeg';

class UserProfileHeader extends Component {

    state = {
        user: Parse.User.current(),
        open: false
    }

    openHandler = () => {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        let dropdown = [
            'UserProfileHeader',
            'dropdown',
            'user',
            'user-menu'
        ];

        if(this.state.open) {
            dropdown.push('open');
        }
        
        return (
            <li className={dropdown.join(' ')}>
                <button onClick={this.openHandler} className="dropdown-toggle" data-toggle="dropdown">
                    <img src={UserLogo} className="user-image" alt={this.state.user.get('fullName')} />
                    <span className="hidden-xs">{this.state.user.get('fullName')}</span>
                </button>
                <ul className="dropdown-menu active">
                    <li className="user-header">
                        <img src={UserLogo} className="img-circle" alt={this.state.user.get('fullName')}/>
                        <p>
                            {this.state.user.get('fullName')}
                        </p>
                    </li>
                    <li className="user-footer">
                        <div className="pull-right">
                            <Link to="/logout" className="btn btn-default btn-flat">Sign out</Link>
                        </div>
                    </li>
                </ul>
            </li>
        );
    }
}

export default UserProfileHeader;